import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-BiKz7_SZ.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const PinOutlinedSize24Component = (props, ref) => (jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.6511 8.5716L13.1564 14.0648L13.5722 16.9745C13.7517 18.2309 13.3691 19.4978 12.535 20.4428L3.55154 11.4619C4.49679 10.6281 5.76405 10.2456 7.02087 10.4251L9.93145 10.8408L15.4262 5.34763L18.6511 8.5716ZM13.8096 21.717C15.0433 20.37 15.6138 18.5373 15.3541 16.72L15.0656 14.701L19.9239 9.84402L21.7272 11.6468L23 10.3744L13.6229 1L12.3501 2.27242L14.1534 4.07521L9.29506 8.93215L7.27545 8.64371C5.45763 8.38408 3.62439 8.95444 2.27699 10.1878C1.83501 10.5923 1.42361 11.0325 1 11.456L6.13914 16.5936L1.00366 21.7276L2.27645 23L7.41193 17.866L12.541 22.9936C12.9646 22.5701 13.4049 22.1588 13.8096 21.717Z", fill: "var(--magritte-ui-icon-color)" }) }));
const PinOutlinedSize24 = hoc(forwardRef(PinOutlinedSize24Component), 'PinOutlinedSize24');

export { PinOutlinedSize24 as default };
//# sourceMappingURL=PinOutlinedSize24.js.map
